import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotificationsRoutes } from '@core';
import {
  AlertSettingsComponent,
  CustomNotificationComponent,
  NotificationPreferencesComponent,
  NotificationsListComponent
} from './components';

const routes: Routes = [
  {
    path: NotificationsRoutes.ROOT,
    component: NotificationsListComponent
  },
  {
    path: NotificationsRoutes.ALERTS,
    component: AlertSettingsComponent
  },
  {
    path: NotificationsRoutes.PREFERENCES,
    component: NotificationPreferencesComponent
  },
  {
    path: `${NotificationsRoutes.CUSTOM_NOTIFICATION}/:id`,
    component: CustomNotificationComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NotificationsRoutingModule {}
